/* eslint-disable react/destructuring-assignment */
import React from "react";

export const DashboardArrow = props => {
  return (
    <svg
      {...props}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        d="M4.70669 9.33332L7.37335 9.33332L7.37335 3.38665L8.71335 3.36665L8.71335 9.33332L11.3734 9.33332L8.04002 12.6667L4.70669 9.33332Z"
        fill={props.color || "#EF4444"}
      />
    </svg>
  );
};
